"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DRAWER_WIDTH = void 0;
/* eslint-disable import/prefer-default-export */
exports.DEFAULT_DRAWER_WIDTH = '500px';
